import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

export default function UserSidebar() {
    let [user, setUser] = useState({})
    let navigate = useNavigate()

    useEffect(() => {
        (async () => {
            let response = await fetch("/api/user/" + localStorage.getItem("userid"), {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    "authorization": localStorage.getItem("token")
                }
            })
            response = await response.json()
            if (response.result === "Done")
                setUser(response.data)
            else
                navigate('/login')
        })()
    }, [])

    return (
        <>
            <div className="testimonial-item img-border-radius shadow-sm mb-3 bg-white p-3">
                <div className='d-flex gap-3'>
                    {
                        user?.pic ?
                            <img src={`/${user.pic}`} height={50} width={50} className='rounded-circle' alt="user image" /> :
                            <img src='/img/avatar.jpg' height={50} width={50} className='rounded-circle' alt="user image" />
                    }
                    <div>
                        <span>Hello,</span>
                        <p className='profil_side'><strong>{user.name}</strong></p>
                    </div>
                </div>
            </div>

            <div className="testimonial-item img-border-radius shadow-sm bg-white d-none d-md-block d-lg-block">
                <h5 className='px-4 pt-3'>User History & Details</h5>
                <hr />
                <div>
                    <p className='px-4 p-2 order'><Link to="/profile" className="text-dark active">My Profile</Link></p>
                    <p className='px-4 p-2 order'><Link to="/order" className="text-dark active">Orders</Link></p>
                    <p className='px-4 p-2 order'><Link to="/wishlist" className="text-dark active">Wishlist</Link></p>
                    <p className='px-4 p-2 order'><Link to="/cart" className="text-dark active">Cart</Link></p>
                </div>
                <hr />
                <p className='px-4 pb-3'><i className='fa fa-sign-out-alt me-2'></i><Link to="/logout" className="text-dark active">Logout</Link></p>
            </div>
        </>
    )
}
